
import { overrideStore, parametrize } from 'react-overridable';

import { RecordsList } from '@js/oarepo_ui/search/RecordsList';
import DatasetResultsListItem from '@js/dataset/search/ResultsListItem';
const RecordsListWithProps = parametrize(RecordsList, { searchEndpoint: "/search" });

overrideStore.add('InvenioAppRDM.RecordsList.layout', RecordsListWithProps);
overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://dataset-v1.0.0.json', DatasetResultsListItem);
